import script from "./WidgetMonEquipe.vue?vue&type=script&setup=true&lang=js"
export * from "./WidgetMonEquipe.vue?vue&type=script&setup=true&lang=js"

import "./WidgetMonEquipe.vue?vue&type=style&index=0&id=965fa304&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-965fa304"]])

export default __exports__